import { Typography } from '@mui/material';
import React from 'react';

export type ExtraData = {
  enableText: string;
  disabledText: string;
};

interface Props {
  cellContent: string;
  formatExtraData: ExtraData;
}

export default function StateColumnFormatter(props: Props) {
  const { cellContent, formatExtraData } = props;
  const isEnable = cellContent === '1';

  return (
    <Typography
      variant="inherit"
      sx={{
        color: isEnable ? '#3E9B2F' : '#CB333B',
        fontWeight: 400,
        fontSize: 16,
      }}
    >
      {isEnable ? formatExtraData.enableText : formatExtraData.disabledText}
    </Typography>
  );
}
